import { MagnetKeyType, MagnetSeniorType } from "@libs/types/enum";
import { DeviceMapKey } from "./device";
import { KIO, KeyMap, OutputMode, VirtualMars68 } from "@hid/define/define";
import { DVKFromVK, HIDFromVk } from "@hid/define/define_fn";
import { DeviceProtocol } from "@hid/device/device_model";

export enum RoyuanMagnetOptions {
    PRESS_TRAVEL = 0,
    RELEASE_TRAVEL = 1,
    RT_PRESS_TRAVEL = 2,
    RT_RELEASE_TRAVEL = 3,
    DYNAMIC_PRESS_TRAVEL = 4,
    MT_LONG_PRESS_TIME = 5,
    DEADZONE = 6,
    KEY_MODE = 7,
    DYNAMIC_KEY_FLAG = 8,
    KME = 9,
    DYNAMIC_KEY_FLAG2 = 10,
    KEY_PRESS_DYNAMIC_VALUE = 0xFF,  //按键按压的动态数值
    KEY_PRESS_DYNAMIC_TRAVEL = 0xFE,  //按键按压的动态行程
    AXIS_TYPE = 0xFC
}

//普通键=0，RT |= 0x80, DKS = 2,MT = 3,TGL = 4(长按) TGL_Continue = 5(连点)
export enum RoyuanMagnetMode {
    NORMAL = 0,
    RT = 0x80,
    DKS = 2,
    MT = 3,
    TGL = 4,
    TGL_Continue = 5,
    KME = 7
}

export const royuanMagnetModeConvert = (mode: RoyuanMagnetMode) => {
    let type = 0
    if (mode == RoyuanMagnetMode.MT) {
        type = MagnetKeyType.MT
    } else if (mode == RoyuanMagnetMode.DKS) {
        type = MagnetKeyType.DKS
    } else if (mode == RoyuanMagnetMode.TGL || mode == RoyuanMagnetMode.TGL_Continue) {
        type = MagnetKeyType.TGL
    } else if (mode == RoyuanMagnetMode.KME) {
        type = MagnetKeyType.KME
    }
    return type
}

export const getRoyuanMagnetMode = (type: MagnetSeniorType, tglMode: Number) => {
    let mode = RoyuanMagnetMode.DKS
    if (type == MagnetSeniorType.SeniorKeyTypeMT) {
        mode = RoyuanMagnetMode.MT
    } else if (type == MagnetSeniorType.SeniorKeyTypeTGL) {
        mode = tglMode == RoyuanMagnetMode.TGL_Continue ? RoyuanMagnetMode.TGL_Continue : RoyuanMagnetMode.TGL
    } else if (type == MagnetSeniorType.SeniorKeyTypeKME) {
        mode = RoyuanMagnetMode.KME
    }
    return mode
}

export enum RoyuanSetKeyType {
    Keyboard = 0,
    Mouse = 1,
    Media = 3,
    Macro = 9,
    FN = 0x0a
}

export const RoyuanReportMap = new Map<number, number>([
    [0, 8000],
    [1, 4000],
    [2, 2000],
    [3, 1000],
    [4, 500],
    [5, 250],
    [6, 125]
])

export const RoyuanRTStabMap = new Map<number, number>([
    [0, 0],
    [1, 25],
    [2, 50],
    [3, 75],
    [4, 100],
])


export const RoyuanSendMessage = async (data: number[], deviceHID: DeviceProtocol, isRemoveReportID: boolean = false) => {
    data[7] = (0xff - (data[0] + data[1] + data[2] + data[3] + data[4] + data[5] + data[6])) & 0xff;
    let res = await deviceHID.send(data, true)
    if (isRemoveReportID) {
        res.shift()
        res[63] = 0
    }
    return res;
}

class Nd68 implements DeviceMapKey {

    encodeKey(params: KIO): KeyMap {
        if (params.Output.DataIndex > -1 && params.Output.Mode == OutputMode.Macro) {
            let type = params.Output.Extension[0] > 0 ? params.Output.Extension[0] - 1 : 0
            return [RoyuanSetKeyType.Macro, type, params.Output.DataIndex, 0]
        }

        const setKey = DVKFromVK(params.Output.VK, VirtualMars68, 'hid');

        const setType = (setKey >> 16) & 0xFF;
        const setMid = (setKey >> 8) & 0xFF
        const hid = setKey & 0xFF

        if (params.Input.WithModifier && params.Input.WithModifier.length > 0) {
            const modifierKeys: number[] = []
            params.Input.WithModifier.forEach((item) => {
                const hid = HIDFromVk(item)
                if (hid) {
                    modifierKeys.push(hid)
                }
            })
            if (modifierKeys.length == 1) {
                return [setType, modifierKeys[0], hid, 0]
            } else {
                return [setType, modifierKeys[0], modifierKeys[1], hid]
            }
        }

        if (setType == RoyuanSetKeyType.Media) {
            return [RoyuanSetKeyType.Media, 0, hid, setMid]
        }
        if (((setKey << 3) | 0x02) == RoyuanSetKeyType.FN) {
            return [RoyuanSetKeyType.FN, hid, 0, 0]
        }
        if (setType == RoyuanSetKeyType.Mouse) {
            return [setType, 0, setKey, setMid]
        }
        return [setType, 0, setKey, 0]
    }
}

export const nd68Data = new Nd68();
